import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "chevron",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5297 2.46888C15.46 2.39903 15.3772 2.34362 15.2861 2.30581C15.195 2.268 15.0973 2.24854 14.9987 2.24854C14.9 2.24854 14.8023 2.268 14.7112 2.30581C14.6201 2.34362 14.5373 2.39903 14.4677 2.46888L5.46766 11.4689C5.39781 11.5385 5.3424 11.6213 5.30459 11.7124C5.26678 11.8035 5.24732 11.9012 5.24732 11.9999C5.24732 12.0985 5.26678 12.1962 5.30459 12.2873C5.3424 12.3784 5.39781 12.4612 5.46766 12.5309L14.4677 21.5309C14.6085 21.6717 14.7995 21.7508 14.9987 21.7508C15.1978 21.7508 15.3888 21.6717 15.5297 21.5309C15.6705 21.39 15.7496 21.199 15.7496 20.9999C15.7496 20.8007 15.6705 20.6097 15.5297 20.4689L7.05916 11.9999L15.5297 3.53088C15.5995 3.46121 15.6549 3.37844 15.6927 3.28733C15.7305 3.19621 15.75 3.09853 15.75 2.99988C15.75 2.90122 15.7305 2.80354 15.6927 2.71243C15.6549 2.62131 15.5995 2.53854 15.5297 2.46888Z",
			fill: "currentColor"
		})
	})
});
export default SvgChevron;
